import React, { useState, useEffect } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { projectsAPI } from "@/api/projects";

interface ProjectFieldProps {
  projectId: string;
  onProjectChange: (projectId: string) => void;
}

const ProjectField: React.FC<ProjectFieldProps> = ({
  projectId,
  onProjectChange,
}) => {
  const [projects, setProjects] = useState<{ id: string; name: string }[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch projects from the API
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setIsLoading(true);
        const data = await projectsAPI.getProjects();
        
        // Map the data to simplified format for the dropdown
        const mappedProjects = data.map(project => ({
          id: project.id,
          name: project.name
        }));
        setProjects(mappedProjects);
      } catch (error) {
        
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <div className="space-y-1.5">
      <label htmlFor="project" className="block text-[11px] font-semibold uppercase tracking-[0.04em] text-gray-600">
        Proje
      </label>
      <Select
        value={projectId}
        onValueChange={onProjectChange}
      >
        <SelectTrigger className="w-full border-gray-200 bg-white rounded-md h-10 text-[13px] text-gray-900 focus:border-brand-600 focus:ring-1 focus:ring-brand-300">
          {isLoading ? (
            <div className="flex items-center text-gray-500">
              <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              <span className="text-[13px]">Yükleniyor...</span>
            </div>
          ) : (
            <SelectValue placeholder="Proje seçin" />
          )}
        </SelectTrigger>
        <SelectContent>
          {projects.map(project => (
            <SelectItem key={project.id} value={project.id}>
              {project.name}
            </SelectItem>
          ))}
          {projects.length === 0 && !isLoading && (
            <div className="py-2 px-4 text-[13px] text-gray-500">
              Proje bulunamadı
            </div>
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

export default ProjectField;
